<template>
    <div class="m-content" id="userInfo">
        <div class="block">
            <el-image :src="src">
                <div slot="placeholder" class="image-slot">
                    加载中<span class="dot">...</span>
                </div>
            </el-image>
        </div>
        <el-button type="info" @click="returnActivities" class="btn-success" style="width:100%; margin-top: 6px;"
            v-show="btnVisible">返回</el-button>
    </div>
</template>

<script>
import { mapState } from 'vuex'
import { Form, FormItem, Select, Option, Input, Radio, RadioGroup } from 'element-ui'
import axios from 'axios';
import qs from 'qs';
export default {
    name: 'OrganiserIntroduction',
    components: {
        ElForm: Form,
        ElFormItem: FormItem,
        ElInput: Input,
        ElSelect: Select,
        ElOption: Option,
        ElRadio: Radio,
        ElRadioGroup: RadioGroup,
    },
    data() {
        return {
            form: {
                name: '',
                gender: '',
                studentUniversity: '',
                studentCollege: '',
                studentDegree: '',
                studentMajor: '',
                studentNo: '',
                campusName: '',
            },
            universities: [],
            colleges: [],
            major: [],
            operators: [],
            btnVisible: false,
            src: '',
        }
    },
    computed: {
        ...mapState({
            shengyaUser: state => state.shengyaUser.userInfo,
        })
    },
    created() {
        this.universities.push(this.shengyaUser.studentUniversity);
        this.getUserInfo();
    },
    methods: {
        returnActivities() {
            this.$emit('return-activities')
        },
        findOperators() {
            const _this = this;
            const options = {
                method: 'POST',
                data: qs.stringify({
                    adminCode: this.shengyaUser.admin.manageAccCode,
                }),
                url: '/cob/findOperators.do'
            }
            axios(options)
                .then((res) => {
                    res = res.data
                    if (res.result.success) {
                        _this.operators = res.data;
                    }
                })
                .catch(function (error) {
                    console.log(error);
                })
        },
        getUserInfo() {
            if (this.shengyaUser.studentUniversity) {
                this.btnVisible = true;
                this.form.studentUniversity = this.shengyaUser.studentUniversity
                //校区
                this.findOperators();
                if (this.shengyaUser.operator && this.shengyaUser.operator.admin.manageAccCode == this.shengyaUser.admin.manageAccCode)
                    this.form.campusName = this.shengyaUser.operator.campusName
                console.info(this.shengyaUser.operator.admin.manageAccCode);
                this.src = 'http://sys.rennengda.com/weekon/cos/images/splash-' + this.shengyaUser.operator.admin.manageAccCode.replace('admin', '') + '.jpg'
            }
        }
    }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" scoped>
  .m-content
    form
      border-top:1px solid #d5d5d5
      margin:0.4rem
  .info-text
    font-size: 0.32rem
    padding: 0.2rem 0.4rem 0 0.4rem
  .form-label
    display: block
    font-weight: bold
    span
      color:#E13716
      font-weight:bold
      font-size: 0.36rem
  .el-radio-group
    .el-radio
      margin-right:0
      background-color :#FFFFFF
      padding:0.2rem 3rem 0.2rem 0.2rem
      border:1px solid #d5d5d5
</style>
